import styled from "styled-components";

export const AppendixBody = styled.div`
  &&& {
    white-space: nowrap;
    font-size: 16px;
    padding: 25px 50px 0 60px;

    @media print {
      padding: 15px 65px 0 45px;
    }

    h3 {
      font-size: 18px;
      font-weight: normal;
      margin: 0;
      padding: 0;
    }
    h4 {
      font-size: 18px;
      font-weight: normal;
      margin: 0;
      padding: 0;
    }
    .column {
      font-family: "Roboto", sans-serif;
      font-weight: bold;
      position: relative;
      text-align: center;
      &:first-child {
        text-align: left;
        width: 290px;
        max-width: 290px;
      }
      &:nth-child(2) {
        width: 180px;
        max-width: 180px;
      }
      &:nth-child(3),
      &:nth-child(4) {
        width: 120px;
        max-width: 120px;
      }
    }
    .row {
      padding: 5px 0;
    }
    .extra-bottom-pad-row {
      padding-bottom: 10px;
    }
  }
`;

export const AppendixFooter = styled.div`
  &&& {
    margin: 0;
    position: absolute;
    left: 35px;
    bottom: 105px;
    p {
      margin: 0;
      font-size: 16px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/Appendix/style.js